import React from "react";
import { AnimatePresence } from "framer-motion";
import StepName from "./Steps/StepName";
import StepBirthDate from "./Steps/StepBirthDate";
import StepBirthTime from "./Steps/StepBirthTime";
import StepGender from "./Steps/StepGender";
import styles from "./OnboardingPage.module.css";
import { useFormDataStore } from "../../store/formDataStore";

const OnboardingPage: React.FC = () => {
  const step = useFormDataStore((state) => state.step);
  const setStep = useFormDataStore((state) => state.setStep);

  const next = () => setStep(step + 1);
  const back = () => setStep(step - 1);

  const steps = [
    <StepName key="step-name" onNext={next} />,
    <StepBirthDate key="step-birth-date" onNext={next} onBack={back} />,
    <StepBirthTime key="step-birth-time" onNext={next} onBack={back} />,
    <StepGender key="step-gender" onBack={back} />,
  ];

  return (
    <div className={styles.container}>
      <div className={styles["progress-indicators"]}>
        {steps.map((_, index) => (
          <div
            key={index}
            className={`${styles["progress-dot"]} ${index <= step ? styles["active"] : ""}`}
          />
        ))}
      </div>

      <AnimatePresence mode="wait">
        <div className={styles["step-content"]}>{steps[step]}</div>
      </AnimatePresence>
    </div>
  );
};

export default OnboardingPage;
